import { MdDone } from "react-icons/md";

interface IProps {
  progress: number;
  isComplete?: boolean;
  isCurrent?: boolean;
}

const ProgressBarV1 = ({
  progress = 0,
  isComplete = false,
  isCurrent = false,
}: IProps) => {
  if (isComplete) {
    return (
      <div className="h-6 w-6 bg-main-button-v2 rounded-full flex items-center justify-center">
        <MdDone className="text-white" />
      </div>
    );
  }

  return (
    <div className="h-3 w-full bg-[#0620881A] rounded-full overflow-hidden">
      <div
        className="transition-all duration-500 ease-in-out bg-dark-purple-2 h-full rounded-full"
        style={{ width: `${progress}%`, minWidth: isCurrent ? "1rem" : "0" }}
      />
    </div>
  );
};

export { ProgressBarV1 };
